import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  private readonly url = environment.api;

  constructor(private http: HttpClient) {}

  private buildAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('auth_token') || '';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return headers;
  }

  /**
   * Returns list of currencies for select controls.
   */
  getCurrencys(): Observable<any> {
    // spelling kept as provided
    const path = `${this.url}/api/v1/currency/for-select`;
    return this.http.get(path, { headers: this.buildAuthHeaders() });
  }

  /**
   * Current exchange rate (with optional first-day rate usage)
   * @param sci ServiceCenterId
   * @param currencyid CurrencyId
   * @param firstDayRate boolean or flag controlling first-day rate usage
   */
  getTasa(sci: any, currencyid: any, firstDayRate?: any): Observable<any> {
    const path = `${this.url}/api/v1/exchange-rate/current-rate?ServiceCenterId=${sci}&CurrencyId=${currencyid}&useFirstDayRate=${firstDayRate}`;
    return this.http.get(path, { headers: this.buildAuthHeaders() });
  }
  /**
   * Duplicate of getCurrencys as requested (kept for backwards compatibility)
   */
  getCurrencySelect(): Observable<any> {
    const path = `${this.url}/api/v1/currency/for-select`;
    return this.http.get(path, { headers: this.buildAuthHeaders() });
  }

  /**
   * Retrieve a single currency by id
   */
  getCurrency(currencyid: string): Observable<any> {
    // Defensive: avoid calling backend with invalid ids like undefined/null/empty
    if (!currencyid || currencyid === 'undefined' || currencyid === 'null') {
      console.warn(
        '[CurrencyService] getCurrency called with invalid id:',
        currencyid
      );
      return of(null);
    }
    const path = `${this.url}/api/v1/currency/${currencyid}`;
    return this.http.get(path, { headers: this.buildAuthHeaders() });
  }
}
